import React from "react";
import "./Notification.scss";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";

const Notification = () => {
  // Создаём массив из 8 элементов (от 1 до 8)
  const notifications = Array.from({ length: 8 }, (_, i) => ({
    id: i + 1,
    title: "ESSTECH",
    text: "Кстати, акционеры крупнейших компаний призваны к ответу. Современные технологии достигли такого уровня.",
    date: "09.03.2024"
  }));

  return (
    <>
      <Header />
      <SubHeader />

      <div className="row notification">
        <div className="col">
          <div className="card">
            <div className="row">
              {notifications.map((notif) => (
                <div key={notif.id} className="col col-12 col-md-4 notification-container">
                  <div className="card-notification">
                    <h2>{notif.title}</h2>
                    <p>{notif.text}</p>
                    <span>{notif.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notification;
